import React, { Component } from 'react'

// components
import Left from './left/Left';
import Right from './right/Right';
import LRWrapper from '../../common/LRWrapper';


export default class Home extends Component {

    static displayName = Home.name;


    render() {
        
        return (

    
            <LRWrapper id="home" bg_image="/assets/image/background/1.png">
                <Left />
                <Right />
            </LRWrapper>

        );

    }


}

